import { render, staticRenderFns } from "./FeatureListPanel.vue?vue&type=template&id=7b20a42d&scoped=true"
import script from "./FeatureListPanel.vue?vue&type=script&lang=ts"
export * from "./FeatureListPanel.vue?vue&type=script&lang=ts"
import style0 from "./FeatureListPanel.vue?vue&type=style&index=0&id=7b20a42d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b20a42d",
  null
  
)

export default component.exports